/* eslint-disable @typescript-eslint/no-explicit-any */
import { defineComponent, h, PropType } from 'vue'
import { ComplexList, DefaultList } from 'complex-data'
import { MenuDataInitOption } from 'complex-data/src/mod/MenuData'
import { ComplexAutoModal, ComplexTableView, ComplexEditForm, ComplexSearchForm } from 'complex-component/antd'
import { renderDataType } from 'complex-component/src/antd/data/TableView'
import { notice } from 'complex-plugin'
import AntdSpin from './AntdSpin.vue'
import { Button } from 'ant-design-vue'
import { ButtonType } from 'ant-design-vue/lib/button'

export type menuItemType = {
  name: string
  prop: string
  hidden?: boolean | ((payload: renderDataType) => undefined | boolean)
  option?: Record<PropertyKey, any>
}

export type optionType = {
  search?: any
  searchMenu?: MenuDataInitOption[]
  table?: any
  menu?: {
    option?: Record<PropertyKey, any>
    list: menuItemType[]
  }
  edit?: any
  info?: any
}

export default defineComponent({
  name: 'ListView',
  props: {
    complexList: {
      type: Object as PropType<ComplexList>,
      required: true
    },
    option: {
      type: Object as PropType<optionType>,
      required: false,
      default: function() {
        return {}
      }
    },
    defaultSearch: {
      type: Object,
      required: false
    },
    hideSpin: {
      type: Boolean,
      required: false,
      default: false
    },
    onlyEdit: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    pageList() {
      return this.complexList.$getDictionaryPageList('list') as DefaultList[]
    },
    searchOption() {
      if (this.option.search !== false) {
        const searchOption = {
          layout: 'horizontal',
          ...this.option.search
        }
        return searchOption
      } else {
        return undefined
      }
    },
    menuOption() {
      const menuOption = {
        ...this.option.menu
      }
      if (!menuOption.list) {
        menuOption.list = []
      }
      return menuOption
    },
    editOption() {
      if (this.option.edit === false) {
        return undefined
      }
      const edit = this.option.edit || {}
      const editOption = {
        modal: {
          ...edit.modal
        },
        form: {
          ...edit.form
        }
      }
      if (!editOption.modal.formatName) {
        editOption.modal.formatName = function(name: string) { return name }
      }
      if (!editOption.modal.optionProps) {
        editOption.modal.optionProps = {}
      }
      if (!editOption.modal.optionProps.width) {
        editOption.modal.optionProps.width = 640
      }
      if (!editOption.modal.optionProps.okText) {
        editOption.modal.optionProps.okText = '确认'
      }
      if (editOption.modal.optionProps.destroyOnClose === undefined) {
        editOption.modal.optionProps.destroyOnClose = true
      }
      if (editOption.modal.optionProps.maskClosable === undefined) {
        editOption.modal.optionProps.maskClosable = false
      }
      return editOption
    },
    infoOption() {
      if (!this.option.info) {
        return undefined
      }
      const info = this.option.info
      const infoOption = {
        modal: {
          ...info.modal
        },
        form: {
          ...info.form
        }
      }
      if (infoOption.modal.menuType === undefined) {
        infoOption.modal.menuType = {
          target: 'cancel',
          type: 'default',
          name: '关闭'
        }
      }
      if (!infoOption.modal.formatName) {
        infoOption.modal.formatName = function(name: string) { return name }
      }
      if (!infoOption.modal.optionProps) {
        infoOption.modal.optionProps = {}
      }
      if (!infoOption.modal.optionProps.width) {
        infoOption.modal.optionProps.width = 640
      }
      if (infoOption.modal.optionProps.destroyOnClose === undefined) {
        infoOption.modal.optionProps.destroyOnClose = true
      }
      if (infoOption.modal.optionProps.maskClosable === undefined) {
        infoOption.modal.optionProps.maskClosable = true
      }
      return infoOption
    },
    operate() {
      return this.complexList.$getStatus('operate')
    }
  },
  mounted() {
    if (this.searchOption && this.complexList.$module.search) {
      this.$nextTick(() => {
        (this.$refs['search-form'] as any)?.show()
      })
    }
  },
  methods: {
    renderSpin() {
      if (!this.hideSpin) {
        return h(AntdSpin, { spinning: this.operate === 'ing' })
      } else {
        return null
      }
    },
    renderSearch() {
      if (this.searchOption && this.complexList.$module.search) {
        const searchFormOption = {
          ...this.searchOption,
          ref: 'search-form',
          search: this.complexList.$module.search,
          type: this.complexList.$module.search.$mod,
          defaultData: this.defaultSearch,
          onMenu: this.onSearchMenu
        }
        return h('div', { class: 'list-view-search' }, [
          h(ComplexSearchForm, searchFormOption),
          this.renderSearchMenu()
        ])
      } else {
        return null
      }
    },
    renderSearchMenu() {
      if (this.option.searchMenu && this.option.searchMenu.length > 0) {
        const list = this.option.searchMenu.map((item, index) => {
          const loading = typeof item.loading === 'function' ? item.loading() : item.loading
          const disabled = typeof item.disabled === 'function' ? item.disabled() : item.disabled
          return h(Button, {
            type: item.type as ButtonType,
            loading: loading,
            disabled: disabled,
            onClick: () => {
              this.onSearchMenu(item.prop)
            },
            style: {
              marginRight: index < (this.option.searchMenu!.length - 1) ? '16px' : '',
              marginBottom: '16px'
            }
          }, {
            default: () => item.name
          })
        })
        return h('div', { class: 'list-view-search-menu' }, list)
      } else {
        return null
      }
    },
    onSearchMenu(prop: string, ...args: any[]) {
      this.$emit('menu', 'search', prop, ...args)
      if (prop === 'setSearch') {
        this.complexList.$setSearch()
      } else if (prop === 'resetSearch') {
        this.complexList.$resetSearch()
      } else if (prop === 'build') {
        this.onEdit()
      } else if (prop === 'delete') {
        notice.confirm('确认进行删除操作吗？', '警告', (act: string) => {
          if (act === 'ok') {
            this.complexList.$triggerMethod('deleteItem', [], true)
          }
        })
      } else if (prop === 'export') {
        this.complexList.$triggerMethod('exportData', [], true)
      }
    },
    renderTop() {
      if (this.$slots.top) {
        return this.$slots.top()
      } else {
        return null
      }
    },
    renderTable() {
      const tableOption = {
        listData: this.complexList,
        columnList: this.pageList,
        style: {
          width: '100%'
        },
        ...this.option.table
      }
      const tableSlot = {
        menu: (payload: renderDataType) => {
          return this.renderMenu(payload)
        }
      }
      return h(ComplexTableView, tableOption, tableSlot)
    },
    renderMenu(payload: renderDataType) {
      return h('span', {
        class: 'local-main-table-menu-list',
        ...this.menuOption.option
      }, {
        default: () => {
          return this.renderMenuList(this.menuOption.list!, payload)
        }
      })
    },
    renderMenuList(menuList: menuItemType[], payload: renderDataType) {
      const list: any[] = []
      for (let i = 0; i < menuList.length; i++) {
        const menuItem = menuList[i]
        let hidden = menuItem.hidden
        if (hidden) {
          if (typeof hidden === 'function') {
            hidden = hidden(payload)
          }
          if (hidden) {
            continue
          }
        }
        list.push(h('span', {
          onClick: () => {
            this.onTableMenu(menuItem.prop, payload)
          },
          ...menuItem.option
        }, {
          default: () => menuItem.name
        }))
      }
      return list
    },
    renderEdit() {
      if (this.editOption) {
        const editModalOption = {
          ref: 'edit-modal',
          optionProps: this.editOption.modal.optionProps,
          auto: { ok: false },
          onEvent: this.onEditMenu
        }
        const editModalSlot = {
          default: () => {
            const editFormOption = {
              ref: 'edit-form',
              dictionary: this.complexList.$module.dictionary!
            }
            return h(ComplexEditForm, editFormOption)
          }
        }
        return h(ComplexAutoModal, editModalOption, editModalSlot)
      } else {
        return null
      }
    },
    renderInfo() {
      if (this.infoOption) {
        const infoModalOption = {
          ref: 'info-modal',
          menuType: this.infoOption.modal.menuType,
          optionProps: this.infoOption.modal.optionProps,
        }
        const infoModalSlot = {
          default: () => {
            const infoFormOption = {
              ref: 'info-form',
              dictionary: this.complexList.$module.dictionary!,
              disabled: true
            }
            return h(ComplexEditForm, infoFormOption)
          }
        }
        return h(ComplexAutoModal, infoModalOption, infoModalSlot)
      } else {
        return null
      }
    },
    onEditMenu(act: string) {
      if (act === 'ok') {
        (this.$refs['edit-form'] as any).handle((targetData: Record<string, any>, originData: Record<string, any>, type: string) => {
          if (type === 'change') {
            this.complexList.$triggerMethod('changeItem', [targetData, originData], true).then(() => {
              (this.$refs['edit-modal'] as any).hide()
            })
          } else if (type === 'build') {
            this.complexList.$triggerMethod('buildItem', [targetData, originData], true).then(() => {
              (this.$refs['edit-modal'] as any).hide()
            })
          }
        })
      }
    },
    onEdit(record?: Record<PropertyKey, unknown>) {
      let name = '新增'
      if (record) {
        name = '编辑'
        if ((this.complexList as any).getInfo) {
          this.complexList.$triggerMethod('getInfo', [record], false).then(() => {
            this.openEdit('change', name, record)
          })
        } else {
          this.openEdit('change', name, record)
        }
      } else {
        this.openEdit('build', name)
      }
    },
    onInfo(record: Record<PropertyKey, unknown>) {
      const name = '详情'
      if ((this.complexList as any).getInfo) {
        this.complexList.$triggerMethod('getInfo', [record], false).then(() => {
          this.openInfo('detail', name, record)
        })
      } else {
        this.openInfo('detail', name, record)
      }
    },
    openInfo(type: string, name: string, record: Record<PropertyKey, unknown>) {
      (this.$refs['info-modal'] as any).show(this.infoOption?.modal.formatName(this.complexList.$name + name, type))
      this.$nextTick(() => {
        (this.$refs['info-form'] as any).show(type, 'change', record)
      })
    },
    openEdit(type: string, name: string, record?: Record<PropertyKey, unknown>) {
      (this.$refs['edit-modal'] as any).show(this.editOption?.modal.formatName(name + this.complexList.$name, type))
      this.$nextTick(() => {
        (this.$refs['edit-form'] as any).show(type, type, record)
      })
    },
    onTableMenu(act: string, payload?: renderDataType) {
      this.$emit('menu', 'table', act, payload)
      if (act === 'build') {
        this.onEdit()
      } else if (act === 'change') {
        this.onEdit(payload!.record)
      } else if (act === 'detail') {
        this.onInfo(payload!.record)
      } else if (act === 'delete') {
        notice.confirm('确认进行删除操作吗？', '警告', (act: string) => {
          if (act === 'ok') {
            this.complexList.$triggerMethod('deleteItem', [payload!.record], true)
          }
        })
      }
    }
  },
  /**
   * 主要模板
   * @param {*} h createElement
   * @returns {VNode}
   */
  render() {
    if (!this.onlyEdit) {
      const children = [this.renderSpin(), this.renderSearch(), this.renderTop(), this.renderTable(), this.renderInfo(), this.renderEdit()]
      const render = h('div', { class: 'complex-list-view', style: { position: 'relative' } }, {
        default: () => children
      })
      return render
    } else {
      return this.renderEdit()
    }
  }
})
